import React from 'react'
import IndividualHero from '../components/Individuals/IndividualHero'
import CategoriesBanner from '../components/CategoriesBanner'
import Navbar from '../components/Navbar'
import IndividualAbout from '../components/Individuals/IndividualAbout'

function IndividualPage() {
    return (
        <div>
            <CategoriesBanner />
            <Navbar />
            <IndividualHero />
            <IndividualAbout />
        </div>
    )
}

export default IndividualPage